import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    titleWithRessources: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    ressources: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      color: palette.text.primary,
      flexWrap: 'wrap',
      gap: '10px'
    },
    ressource: {
      marginRight: '5px',
      alignItems: 'center'
    },
    buttonsBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
